module.exports = __webpack_public_path__ + "img/down-arrow.2ed044f8.svg";